import { SearchField } from '@/components/custom/erp';
import { FormField } from '@/components/custom/erp';
import { taxSearchColumns } from '../../cols-definition';
import { COMPANY_NAME } from '@/constants/header';
import { Label } from '@/components/ui/label';
import { CoQuanThue } from '@/types/schemas';

interface BasicInfoTabProps {
  formMode: 'add' | 'edit' | 'view';
  taxAuthorityCuc: CoQuanThue | null;
  taxAuthorityManagement: CoQuanThue | null;
  setTaxAuthorityCuc: (taxAuthority: CoQuanThue) => void;
  setTaxAuthorityManagement: (taxAuthority: CoQuanThue) => void;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({
  formMode,
  taxAuthorityCuc,
  taxAuthorityManagement,
  setTaxAuthorityCuc,
  setTaxAuthorityManagement
}) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center gap-2'>
          <div className='flex items-center gap-2'>
            <Label className='w-40 min-w-40'>Đơn vị</Label>
            <div className='w-[250px]'>
              <FormField
                type='select'
                name='company'
                disabled={formMode === 'view'}
                options={[
                  { label: 'Tất cả', value: 'all' },
                  { label: `${COMPANY_NAME}`, value: 'company_a' }
                ]}
                defaultValue={'all'}
              />
            </div>
          </div>

          <div className='flex items-center'>
            <FormField type='checkbox' label='Phân bổ thuế' name='tax_allocation' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <div className='flex items-center gap-2'>
            <Label className='w-40 min-w-40'>Mã số thuế</Label>
            <div className='w-[250px]'>
              <FormField type='text' name='tax_code' disabled={formMode === 'view'} />
            </div>
          </div>

          <div className='flex items-center gap-2'>
            <FormField
              type='checkbox'
              label='Quyết toán thuế theo uỷ quyền của cá nhân được điều chuyển'
              name='authorized_tax_finalization'
              disabled={formMode === 'view'}
            />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Tên công ty</Label>
          <div className='w-full'>
            <FormField type='text' name='company_name' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Địa chỉ</Label>
          <div className='w-full'>
            <FormField type='text' name='address' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Người liên hệ</Label>
          <div className='w-[250px]'>
            <FormField type='text' name='contact_person' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Người ký</Label>
          <div className='w-[250px]'>
            <FormField type='text' name='signer' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <div className='flex items-center gap-2'>
            <Label className='w-40 min-w-40'>Thư</Label>
            <div className='w-[250px]'>
              <FormField type='text' name='mail' disabled={formMode === 'view'} />
            </div>
          </div>

          <div className='flex items-center gap-2'>
            <Label className='w-20 min-w-20'>Điện thoại</Label>
            <div className='w-[250px]'>
              <FormField type='text' name='phone' disabled={formMode === 'view'} />
            </div>
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Tỉnh/Thành</Label>
          <div className='w-[250px]'>
            <FormField
              type='select'
              name='city'
              disabled={formMode === 'view'}
              options={[
                { label: 'Thành phố Hà Nội', value: 1 },
                { label: 'Tỉnh Hà Giang', value: 2 },
                { label: 'Tỉnh Cao Bằng', value: 3 },
                { label: 'Tỉnh Bắc Kạn', value: 4 },
                { label: 'Tỉnh Tuyên Quang', value: 5 },
                { label: 'Tỉnh Lào Cai', value: 6 },
                { label: 'Tỉnh Điện Biên', value: 7 },
                { label: 'Tỉnh Lai Châu', value: 8 },
                { label: 'Tỉnh Sơn La', value: 9 },
                { label: 'Tỉnh Yên Bái', value: 10 }
              ]}
            />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Quận/Thành</Label>
          <div className='w-[250px]'>
            <FormField type='select' name='district' disabled={formMode === 'view'} options={[]} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Xã/Phường</Label>
          <div className='w-[250px]'>
            <FormField type='select' name='ward' disabled={formMode === 'view'} options={[]} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Fax</Label>
          <div className='w-[250px]'>
            <FormField type='text' name='fax' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Ngành nghề kinh doanh</Label>
          <div className='w-[350px]'>
            <FormField
              type='select'
              name='industry'
              disabled={formMode === 'view'}
              options={[{ label: 'Hoạt động sản xuất kinh doanh thông thường', value: '1' }]}
              defaultValue={'1'}
            />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Cơ quan thuế cấp Cục</Label>
          <div className='w-[350px]'>
            <SearchField<CoQuanThue>
              type='text'
              disabled={formMode === 'view'}
              searchEndpoint='/tax-authorities/'
              searchColumns={taxSearchColumns}
              displayRelatedField='ten_cqt'
              dialogTitle='Cơ quan thuế cấp Cục'
              columnDisplay='ma_cqt'
              value={taxAuthorityCuc?.ma_cqt || ''}
              onRowSelection={setTaxAuthorityCuc}
            />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Cơ quan thuế quản lý</Label>
          <div className='w-[350px]'>
            <SearchField<CoQuanThue>
              type='text'
              disabled={formMode === 'view'}
              searchEndpoint='/tax-authorities/'
              displayRelatedField='ten_cqt'
              searchColumns={taxSearchColumns}
              dialogTitle='Cơ quan thuế quản lý'
              columnDisplay='ma_cqt'
              value={taxAuthorityManagement?.ma_cqt || ''}
              onRowSelection={setTaxAuthorityManagement}
            />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <Label className='w-40 min-w-40'>Trạng thái</Label>
          <div className='w-[250px]'>
            <FormField
              type='select'
              name='status'
              disabled={formMode === 'view'}
              options={[
                { label: '1. Còn sử dụng', value: '1' },
                { label: '0. Không sử dụng', value: '0' }
              ]}
              defaultValue={'1'}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
